import { Component } from '@angular/core';
import { MonitorService } from '../monitor.service';
import moment from 'moment-timezone';
import { Observable } from 'rxjs';

@Component({
  selector: 'lms-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss']
})
export class ActivityComponent {
  public licensesResult$: Observable<any>;
  public groupsResult$: Observable<any>;
  public date = moment().toISOString();
  public currentDate = moment().toISOString();

  constructor(public monitor: MonitorService) {}

  getActivityByMongoose() {
    this.licensesResult$ = this.monitor.getLicensesActivity(this.date);
    this.groupsResult$ = this.monitor.getGroupsActivity(this.date);
  }

  getActivityByCrawler() {
    this.licensesResult$ = this.monitor.getLicensesActivityByCrawler(this.date);
    this.groupsResult$ = this.monitor.getGroupsActivityByCrawler(this.date);
  }

  // TODO:
  // onInputFieldChanged(event: IMyInputFieldChanged) {
  //   if (event.value && !event.valid) {
  //     window.alert('Bad date!');
  //   }
  // }

  // onDateChanged(event: IMyDateModel): void {
  //   const { year, month, day } = event.date;
  //   const aux = moment(new Date(year, month - 1, day)).tz('Europe/Madrid');
  //   this.date = this.currentDate = aux.utc().toISOString();
  // }
}
